import { memo } from 'react';
import { translate } from '../../utils';
import { usePortfolioDashboard } from './PortfolioDashboardContext';
import { PortfolioChangePercentage } from './PortfolioChangePercentage';
import { formatMetricValue, getMetricComparisonTranslationKey, getMetricNextComparisonTranslationKey } from './portfolioDashboardUtilities';

/** @typedef {import('./portfolioDashboard.types').PortfolioMetric} PortfolioMetric */
/** @typedef {import('./portfolioDashboard.types').PortfolioMetricDefinition} PortfolioMetricDefinition */
/** @param {{ metricDefinition: PortfolioMetricDefinition, metric: PortfolioMetric, currency: string }} props */
export const PortfolioMetricCard = memo(function PortfolioMetricCard({ metricDefinition, metric, currency }) {
    const { period } = usePortfolioDashboard();
    const changePercentage = metric[metricDefinition.changePercentageField];
    const nextChangePercentage = metric[metricDefinition.nextChangePercentageField];
    const comparisonTranslationKey = getMetricComparisonTranslationKey(period, metricDefinition.usesExtendedComparison);
    const nextComparisonTranslationKey = getMetricNextComparisonTranslationKey(period, metricDefinition.usesExtendedComparison);

    return (
        <div className="g-col-12 g-col-md-6 g-col-xl-2">
            <div className="box box-solid h-full mb-0">
                <div className="box-body flex flex-col justify-between h-full">
                    <div>
                        <div className="flex items-start gap-2 mb-2">
                            <i className={`${metricDefinition.icon} text-body`}></i>

                            {translate('frontend', metricDefinition.labelTranslationKey)}
                        </div>

                        <p className="font-size-h3 mb-1 text-center">
                            {formatMetricValue({ value: metric.value, valueFormat: metricDefinition.valueFormat }, currency)}
                        </p>
                    </div>

                    <div className="flex flex-wrap justify-between items-end gap-2">
                        <div>
                            <PortfolioChangePercentage changePercentage={changePercentage} />

                            <p className="font-size-12 text-muted mb-0">
                                {translate('frontend', comparisonTranslationKey)}
                            </p>
                        </div>

                        <div className="text-right">
                            <PortfolioChangePercentage changePercentage={nextChangePercentage} />

                            <p className="font-size-12 text-muted mb-0">
                                {translate('frontend', nextComparisonTranslationKey)}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
});
